import React from 'react';

import { type ScheduleStatusType } from 'loot-core/src/client/data-hooks/schedules';
import { titleFirst } from 'loot-core/src/shared/util';

import {
  SvgAlertTriangle,
  SvgCalendar,
  SvgCheckCircle1,
  SvgCheckCircleHollow,
  SvgEditSkull1,
  SvgFavoriteStar,
  SvgLockClosed,
  SvgValidationCheck,
} from '../../icons';
import { Text } from '../common/Text';
import { View } from '../common/View';

// Consists of Schedule Statuses + Transaction statuses
type StatusTypes = ScheduleStatusType | 'cleared' | 'pending' | 'reconciled';
export function getStatusProps(status: StatusTypes) {
  switch (status) {
    case 'missed':
      return {
        className: 'text-[var(--color-errorTextDarker)] bg-[var(--color-errorBackground)]',
        Icon: SvgEditSkull1,
      };
    case 'due':
      return {
        className: 'text-[var(--color-warningTextDark)] bg-[var(--color-warningBackground)]',
        Icon: SvgAlertTriangle,
      };
    case 'upcoming':
      return {
        className: 'text-[var(--color-upcomingText)] bg-[var(--color-upcomingBackground)]',
        Icon: SvgCalendar,
      };
    case 'paid':
      return {
        className: 'text-[var(--color-noticeText)] bg-[var(--color-noticeBackgroundLight)]',
        Icon: SvgValidationCheck,
      };
    case 'completed':
      return {
        className: 'text-muted-foreground bg-muted',
        Icon: SvgFavoriteStar,
      };
    case 'pending':
      return {
        className: 'text-[var(--color-noticeTextLight)] bg-[var(--color-noticeBackgroundLight)]',
        Icon: SvgCalendar,
      };
    case 'scheduled':
      return {
        className: 'text-[var(--color-tableRowHeaderText)] bg-muted',
        Icon: SvgCalendar,
      };
    case 'cleared':
      return {
        className: 'text-[var(--color-noticeTextLight)] bg-muted',
        Icon: SvgCheckCircle1,
      };
    case 'reconciled':
      return {
        className: 'text-[var(--color-noticeTextLight)] bg-muted',
        Icon: SvgLockClosed,
      };
    default:
      return {
        className: 'text-[var(--color-buttonNormalDisabledText)] bg-muted',
        Icon: SvgCheckCircleHollow,
      };
  }
}

export function StatusBadge({ status }: { status: ScheduleStatusType }) {
  const { className, Icon } = getStatusProps(status);
  return (
    <View
      className={className}
      style={{
        padding: '6px 8px',
        borderRadius: 4,
        flexDirection: 'row',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      <Icon
        style={{
          width: 13,
          height: 13,
          marginRight: 7,
        }}
      />
      <Text style={{ lineHeight: '1em' }}>{titleFirst(status)}</Text>
    </View>
  );
}
